export default "__VITE_ASSET__b8b33344__"